import { useEffect } from 'react';
import { parseBasketJson, useShoppingBasketCoCo } from '../../../common/hooks/useShoppingBasketCoCo.js';
import { updateAddonGroupSelectionInBasket } from '../../ShoppingBasket/shoppingBasketHelpersCoCo.js';
import type { ProductOfferingCartItems } from '../../../common/types/shoppingBasketCoCo.js';

export interface SyncAddonGroupSelectionOptions {
  basketItem: ProductOfferingCartItems;
  isSelectedOffering?: (offeringName: string) => boolean;
}

export const useBundleAddonGroupSelectionCoCo = ({
  basketItem,
  isSelectedOffering,
}: SyncAddonGroupSelectionOptions) => {
  const { shoppingBasket, setShoppingBasket } = useShoppingBasketCoCo();
  const { cartItemId, bundleAddonGroup } = basketItem;

  useEffect(() => {
    if (!isSelectedOffering) {
      return;
    }
    const matches = (name?: string) => !!name && isSelectedOffering(name.toLowerCase());

    const group = (bundleAddonGroup ?? []).find(g => (g.productOffering ?? []).some(o => matches(o.name?.value)));
    if (!group) {
      return;
    }

    const offerings = group.productOffering ?? [];
    const selectedOfferingIds = offerings.filter(o => matches(o.name?.value)).map(o => o.id);
    const alreadySelected = offerings.every(o => !!o.isSelected === selectedOfferingIds.includes(o.id));
    if (alreadySelected) {
      return;
    }

    setShoppingBasket(
      JSON.stringify(
        updateAddonGroupSelectionInBasket(parseBasketJson(shoppingBasket), [cartItemId], group.id, selectedOfferingIds)
      )
    );
  }, [isSelectedOffering, cartItemId, bundleAddonGroup, shoppingBasket, setShoppingBasket]);
};
